// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { inViewAnm, lenisPageScroll , txtAnim , mocPara, inviewAnim } from './libs/Scroll';
import { drawer, fixedHeader } from './libs/Header';
// import { accordionFunc } from './libs/Accordion';
import { addAutoFunc, numKeyFunc } from './libs/Form';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';
// import { mvAnim } from './libs/Mv';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  drawer();
  addAutoFunc();
  numKeyFunc();
  lenisPageScroll();
  txtAnim();
  mocPara();
  inviewAnim();
  // accordionFunc();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  // slider();
  inViewAnm();
  // mvAnim();
});
